import { customFetch } from 'app/pages/frames/helpers/buildFetch';
import { replaceTrailingSlash } from 'common/util/string';

const baseUrl = `${replaceTrailingSlash(import.meta.env.VITE_BASE_URL)}api`;

export const getCheckoutById = async (id: string) => {
  try {
    return await customFetch(`${baseUrl}/checkout/${id}`, { headers: { 'X-Flow': '3ds' } });
  } catch (e) {
    throw e;
  }
};

export const getEntityById = async (id: string) => {
  try {
    return await customFetch(`${baseUrl}/entity/${id}`);
  } catch (e) {
    throw e;
  }
};
